import { VendorCommitmentsLayout as VendorCommitmentsLayoutComponent } from '../../../components/Commitment/CommitmentEvents/VendorCommitmentsLayout';

export function VendorCommitmentLayout() {
  return <VendorCommitmentsLayoutComponent />;
}
